import { Lazy } from '@betgames/bg-state-manager';
import GameMessageStore from './GameMessage.store';

export const gameMessage = new Lazy(() => new GameMessageStore());
